/**
 * DevExtreme (esm/__internal/ui/button/icon.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import { createVNode, createFragment } from "inferno";
import { getImageSourceType } from "../../../core/utils/icon";
import { BaseInfernoComponent } from "../../core/r1/runtime/inferno/index";
import { getTemplate } from "../../core/r1/utils/index";
import { combineClasses } from "../../core/utils/combine_classes";
export const defaultIconProps = {
  position: "left",
  source: ""
};
export let Icon = /*#__PURE__*/(() => {
  class Icon extends BaseInfernoComponent {
    constructor(props) {
      super(props);
      this.state = {};
    }
    get sourceType() {
      return getImageSourceType(this.props.source);
    }
    get cssClass() {
      return "left" !== this.props.position ? "dx-icon-right" : "";
    }
    get iconClassName() {
      const generalClasses = {
        "dx-icon": true,
        [this.cssClass]: !!this.cssClass
      };
      const {
        source: source
      } = this.props;
      if ("dxIcon" === this.sourceType) {
        return combineClasses(_extends({}, generalClasses, {
          [`dx-icon-${source}`]: true
        }));
      }
      if ("fontIcon" === this.sourceType) {
        return combineClasses(_extends({}, generalClasses, {
          [String(source)]: !!source
        }));
      }
      if ("image" === this.sourceType) {
        return combineClasses(generalClasses);
      }
      if ("svg" === this.sourceType) {
        return combineClasses(_extends({}, generalClasses, {
          "dx-svg-icon": true
        }));
      }
      return "";
    }
    render() {
      const {
        iconClassName: iconClassName,
        props: props,
        sourceType: sourceType
      } = this;
      const IconTemplate = getTemplate(props.iconTemplate);
      return createFragment(["dxIcon" === sourceType && createVNode(1, "i", iconClassName), "fontIcon" === sourceType && createVNode(1, "i", iconClassName), "image" === sourceType && createVNode(1, "img", iconClassName, null, 1, {
        alt: "",
        src: props.source
      }), IconTemplate && createVNode(1, "i", iconClassName, IconTemplate({}), 0)], 0);
    }
  }
  Icon.defaultProps = defaultIconProps;
  return Icon;
})();